import { EMvkActionTypes } from '../../actions/mvk';
import { IMVK } from '../../types/mvk';
import { TReduxActions } from '../../types/redux';

const DEFAULT_MVK_STATE = {
  hasMVK: false,
  isLoadingError: false,
};

export function mvkReducer(state: IMVK = DEFAULT_MVK_STATE, action: TReduxActions): IMVK {
  switch (action.type) {
    case EMvkActionTypes.SetMvk:
      return {
        ...state,
        mvkData: action.payload,
      };

    case EMvkActionTypes.SetMvkLoadingError:
      return {
        ...state,
        isLoadingError: action.payload,
      };
    default:
      return state;
  }
}
